<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title>
        <h1 class="subheading">Store List</h1>
      </v-toolbar-title>
      <v-btn
        color="teal"
        dark="dark"
        small="small"
        absolute="absolute"
        bottom="bottom"
        right="right"
        fab="fab"
        @click="create"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-title>
      <v-flex xs12="xs12" md4="md4">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line="single-line"
          hide-details="hide-details"
        >
        </v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table
      :headers="headers"
      v-model="selected"
      :items="location"
      item-key="CSPID"
      :search="search"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left pointer">
            <v-tooltip class="ml-1 pointer" bottom="bottom">
              <template slot="activator">
                <a @click="viewLocationNewTab(props.item)">{{ props.item.CSPID }}</a>
              </template>
              <span>Open in new tab</span>
            </v-tooltip>
            <template v-for="data in props.item.ProductRelations">
              <v-tooltip class="m1-1 pointer" bottom="bottom" v-if="data.isLocked">
                <template slot="activator">
                  <v-icon class="ml-2" small="small" color="red" v-if="data.isLocked">lock</v-icon>
                </template>
                <span>{{ data.name }}</span>
              </v-tooltip>
              <v-tooltip
                class="m1-1 pointer"
                bottom="bottom"
                v-if="data.serviceID == 192 && data.isCanceled == true"
              >
                <template slot="activator">
                  <v-icon
                    class="ml-2"
                    small="small"
                    color="red"
                    v-if="data.serviceID == 192 && data.isCanceled == true"
                    >desktop_access_disabled
                  </v-icon>
                </template>
                <span>{{ data.name }}</span>
              </v-tooltip>
            </template>
          </td>
          <td class="text-xs-left pointer" @click="viewLocation(props.item)">
            <div>
              <v-icon class="ml-1" small="small" v-if="props.item.isCanceled" color="red"
                >desktop_access_disabled </v-icon
              >{{ props.item.businessName }}
            </div>
          </td>
          <td class="text-xs-left pointer" @click="viewLocation(props.item)">
            {{ props.item.businessPhone | USPhoneNumber }}
          </td>
          <td class="text-xs-left pointer">
            <a @click="openGoogleMap(props.item)">{{ props.item.address }}</a>
          </td>
        </tr>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert
      >
    </v-data-table>
  </v-card>
</template>
<script>
import locationService from "../service.js";
import { mapGetters } from "vuex";

export default {
  props: ["location", "title"],
  name: "other-location-list",
  data() {
    return {
      selected: [],
      // expand: false,
      headers: [
        {
          text: this.$t("labels.cspID"),
          align: "left",
          sortable: true,
          value: "CSPID"
        },
        {
          text: this.$t("labels.storeName"),
          value: "businessName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "businessPhone",
          sortable: true
        },
        {
          text: this.$t("labels.address"),
          value: "address",
          sortable: true
        }
        // {
        //   text: this.$t("labels.dueDate"),
        //   value: "dueDate",
        //   sortable: true
        // },
        // {
        //   text: this.$t("labels.dueInDays"),
        //   value: "dueInDays",
        //   sortable: true
        // }
      ],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "businessName"
      }
    };
  },
  computed: {
    ...mapGetters("location", ["organization"])
  },
  methods: {
    create() {
      console.log("this.organization", this.organization);
      this.$router.push({ path: `/location/${this.organization.organizationID}/new` });
    },
    viewLocation(location) {
      this.$router.push({ path: `/location/profile/${location.storeID}` });
      this.$router.go();
    },
    openGoogleMap(location) {
      window.open(
        `https://www.google.com/maps/place/${location.address} ${location.city},${location.State.stateSymbol} ${location.zipCode}`,
        "_blank"
      );
    },
    viewLocationNewTab(location) {
      let routeData = this.$router.resolve({
        path: `/location/profile/${location.storeID}`
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
